<template>
  <v-card outlined>
    <v-card-actions class="py-0">
      <v-toolbar dense flat>
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save()">Speichern</v-btn>
      </v-toolbar>
    </v-card-actions>
    <v-divider></v-divider>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="4">
          <v-card-title>Vereinsanschrift</v-card-title>
          <v-row class="pa-2 pt-4">
            <v-col cols="12" class="pa-1"><v-text-field dense hide-details outlined label="Vereinsname" v-model="settings.name"></v-text-field></v-col>
            <v-col cols="9" class="pa-1"><v-text-field dense hide-details outlined label="Straße" v-model="settings.strasse"></v-text-field></v-col>
            <v-col cols="3" class="pa-1"><v-text-field dense hide-details outlined label="Nr." v-model="settings.hausnummer"></v-text-field></v-col>
            <v-col cols="9" class="pa-1"><v-text-field dense hide-details outlined label="Ort" v-model="settings.ort"></v-text-field></v-col>
            <v-col cols="3" class="pa-1"><v-text-field dense hide-details outlined label="PLZ" v-model="settings.plz"></v-text-field></v-col>
            <v-col cols="12" class="pa-1"><v-text-field dense hide-details outlined label="Land" v-model="settings.land"></v-text-field></v-col>
          </v-row>
        </v-col>
        
        <v-col cols="4">
          <v-card-title>Webadressen</v-card-title>
          <v-row class="pa-2 pt-4">
            <v-col cols="12" class="pa-1"><v-text-field dense hide-details outlined label="Haupt Mailadresse" v-model="settings.mail"></v-text-field></v-col>
            <v-col cols="12" class="pa-1"><v-text-field dense hide-details outlined label="Webseite" v-model="settings.webseite"></v-text-field></v-col>
            <v-col cols="12" class="pa-1"><v-text-field dense hide-details outlined label="Instagram" v-model="settings.instagram"></v-text-field></v-col>
            <v-col cols="12" class="pa-1"><v-text-field dense hide-details outlined label="Facebook" v-model="settings.facebook"></v-text-field></v-col>
          </v-row>
        </v-col>

        <v-col cols="4">
          <v-card-title>Administratoren</v-card-title>
          <v-row class="pa-2 pt-4">
            <v-col cols="12" class="pa-1">
              <v-autocomplete
                v-model="settings.admins"
                :items="bundesbruderselect"
                outlined
                chips
                deletable-chips
                label="Admins"
                multiple
                dense
                hide-details
              > 
                <template v-slot:append-outer>
                  <v-tooltip
                    bottom
                    max-width="200px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">help</v-icon>
                    </template>
                    Admins haben alle Rechte beim Verwenden von Korpodesk. Nur Admins können diese Einstellungen bearbeiten. Es muss min. 1 Admin ausgewählt werden.
                  </v-tooltip>
                </template>
                <template v-slot:selection="data">
                  <v-chip
                    small
                    :input-value="data.selected"
                    :close="settings.admins.length > 1"
                    @click="data.select"
                    @click:close="removeBerechtigung(data.item.value)"
                    class="mt-1"
                  >
                    {{ data.item.text }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.text"></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      selectPicture: {},
      loading: {
        header: false,
        logo: false
      }
    }
  },
  computed: {
    settings () {
      return this.$store.getters['einstellungen/einstellung']('allgemein')
    },
    bundesbruderselect () {
      let items = this.$store.state.bbrbbr.bbrbbr
      let bbrbbr = []
      items.forEach(item => {
        if (item.vulgo) {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ', ' + item.vorname + ' (' + item.vulgo + ')'
          })
        } else {
          bbrbbr.push({
            value: item.id,
            text: item.nachname + ', ' + item.vorname
          })
        }
      })
      return bbrbbr
    }
  },
  methods: {
    removeBerechtigung (item) {
      const index = this.settings.admins.indexOf(item)
      if (index >= 0) this.settings.admins.splice(index, 1)
    },
    uploadLogo () {
      this.loading.logo = true
      this.settings.logo = null
      const storageRef = this.$firebase.storage().ref(`/design/logo/${this.$vars.verbindung}`).put(this.selectPicture.logo)
      storageRef.on(`state_changed`, snapshot => {
        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      }, error => { this.uploadStatus.error = error.message },
      () => {
        storageRef.snapshot.ref.getDownloadURL().then((url) => {
          this.settings.logo = url
          this.loading.logo = false
        })
      })
    },
    uploadHeader () {
      this.loading.header = true
      this.settings.header = null
      const storageRef = this.$firebase.storage().ref(`/design/header/${this.$vars.verbindung}`).put(this.selectPicture.header)
      storageRef.on(`state_changed`, snapshot => {
        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      }, error => { this.uploadStatus.error = error.message },
      () => {
        storageRef.snapshot.ref.getDownloadURL().then((url) => {
          this.settings.header = url
          this.loading.header = false
        })
      })
    },
    uploadBackground () {
      this.loading.background = true
      this.settings.background = null
      const storageRef = this.$firebase.storage().ref(`/design/background/${this.$vars.verbindung}`).put(this.selectPicture.background)
      storageRef.on(`state_changed`, snapshot => {
        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      }, error => { this.uploadStatus.error = error.message },
      () => {
        storageRef.snapshot.ref.getDownloadURL().then((url) => {
          this.settings.background = url
          this.loading.background = false
        })
      })
    },
    save () {
      this.$store.dispatch('einstellungen/updateEinstellungData', this.settings)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Allgemein.vue?21b6e2c7